class HimalayanFinderGate extends HTMLElement {
  #events;
  #frame;
  #focusWhenOpen = false;

  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    this.querySelector('.gate__go a').addEventListener('click', event => {
      event.preventDefault();
      this.open(true);
    }, options);
    document.addEventListener('scroll', () => this.#schedule(), { ...options, capture: true, passive: true });
    window.addEventListener('resize', () => this.#schedule(), options);
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => this.#schedule(), options);
    this.#draw();
  }

  disconnectedCallback() {
    this.#events?.abort();
    cancelAnimationFrame(this.#frame);
    this.#frame = undefined;
  }

  #scrollOwner() {
    for (let node = this.parentElement; node && node !== document.body; node = node.parentElement) {
      if (/(auto|scroll)/.test(getComputedStyle(node).overflowY)) return node;
    }
    return window;
  }

  open(focus = false) {
    const owner = this.#scrollOwner();
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#focusWhenOpen = focus;
    const top = this.querySelector('.gate').getBoundingClientRect().top;
    const viewportTop = owner === window ? 0 : owner.getBoundingClientRect().top;
    const current = owner === window ? scrollY : owner.scrollTop;
    const travel = still ? 0 : this.querySelector('.gate__run').offsetHeight * .55;
    owner.scrollTo({ top: current + top - viewportTop + travel, behavior: still ? 'instant' : 'smooth' });
    this.#schedule();
  }

  #schedule() {
    if (this.#frame !== undefined) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = undefined;
      this.#draw();
    });
  }

  #draw() {
    const gate = this.querySelector('.gate');
    const owner = this.#scrollOwner();
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const viewportTop = owner === window ? 0 : owner.getBoundingClientRect().top;
    const travel = this.querySelector('.gate__run').offsetHeight * .55;
    const p = still ? 1 : Math.min(1, Math.max(0, (viewportTop - gate.getBoundingClientRect().top) / Math.max(1, travel)));
    const eased = 1 - Math.pow(1 - p, 1.7);
    gate.style.setProperty('--p', eased.toFixed(4));
    const left = this.querySelector('.gate__leaf--l').getBoundingClientRect();
    const right = this.querySelector('.gate__leaf--r').getBoundingClientRect();
    gate.style.setProperty('--gap', Math.max(0, right.left - left.right).toFixed(1) + 'px');
    const title = this.querySelector('.gate__title');
    const opacity = Math.max(0, 1 - p * 3.4);
    title.style.setProperty('--t', opacity.toFixed(3));
    title.inert = opacity < .12;
    const ask = this.querySelector('.gate__ask');
    ask.classList.toggle('is-live', eased > .72);
    ask.inert = eased <= .72;
    if (!ask.inert && this.#focusWhenOpen) {
      this.#focusWhenOpen = false;
      ask.querySelector('h2')?.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('himalayan-finder-gate')) customElements.define('himalayan-finder-gate', HimalayanFinderGate);
